import { PaymentDetailSlidein } from '@/components/accounts-payable/payment-detail/payment-detail-slidein';
import { useNavigate, useParams } from '@tanstack/react-router';

export function Route() {
  const params = useParams({ strict: false });
  const paymentId = params.paymentId as string | undefined;
  const navigate = useNavigate();

  if (!paymentId) {
    return null;
  }

  return (
    <PaymentDetailSlidein
      paymentId={paymentId}
      isOpen={true}
      onOpenChange={(open) => {
        if (!open) {
          navigate({
            to: '/accounts-payable/payments',
            // Keep the list's filters/pagination and scroll position.
            search: (prev) => prev,
            resetScroll: false,
            viewTransition: true,
          });
        }
      }}
    />
  );
}
